import { render, staticRenderFns } from "./IntroTemplate.vue?vue&type=template&id=89b2b4a6&scoped=true&"
import script from "./IntroTemplate.vue?vue&type=script&lang=js&"
export * from "./IntroTemplate.vue?vue&type=script&lang=js&"
import style0 from "./IntroTemplate.vue?vue&type=style&index=0&id=89b2b4a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b2b4a6",
  null
  
)

export default component.exports